import { PostHog } from 'posthog-js';
import { FeatureFlagService } from './FeatureFlagService';

import { FeatureFlag } from '~/app/enums/FeatureFlag';
import { useAuthStore } from '~/stores/authStore';

export class PosthogFeatureFlagService implements FeatureFlagService {
    private postHog: PostHog;
    constructor(posthog: PostHog) {
        this.postHog = posthog;
    }

    isDisabled(featureFlag: FeatureFlag, defaultValue?: boolean): boolean {
        const isEnabledDefaultValue = defaultValue === undefined ? undefined : !defaultValue;

        return !this.isEnabled(featureFlag, isEnabledDefaultValue);
    }

    isEnabled(featureFlag: FeatureFlag, defaultValue?: boolean): boolean {
        const isEnabled = this.postHog.isFeatureEnabled(featureFlag, { send_event: !this.isImpersonating });

        if (isEnabled === undefined && defaultValue !== undefined) {
            return defaultValue;
        }

        if (isEnabled === undefined) {
            return false;
        }

        return isEnabled;
    }

    // getFeatureFlag (not isFeatureEnabled) returns the multivariate variant string and is what records
    // the experiment exposure event. A boolean/undefined result means "no variant" -> fall back.
    getVariant(featureFlag: FeatureFlag, defaultValue?: string): string | undefined {
        const variant = this.postHog.getFeatureFlag(featureFlag, { send_event: !this.isImpersonating });

        return typeof variant === 'string' ? variant : defaultValue;
    }

    onFlagsResolved(callback: () => void): void {
        this.postHog.onFeatureFlags(() => callback());
    }

    private get isImpersonating(): boolean {
        return useAuthStore().isImpersonating;
    }
}
